export enum AuditActionEnum {
  Create = 1,
  Update = 2,
  Delete = 3,
  SoftDelete = 4,
  BulkDelete = 5,
  Import = 6,
  PermissionChange = 7,
  BulkCreate = 8,
}

export enum AuditOriginEnum {
  UserInterface = 1,
  PublicApi = 2,
  Scheduler = 3,
  Integration = 4,
}

export interface IAuditChange {
  fieldName: string;
  fieldLabel: string;
  oldValue?: string;
  newValue?: string;
}

export interface IAuditLogGrid {
  id: string;
  timestamp: string;
  entityName: string;
  moduleName: string;
  entityId: string;
  entityDisplayName?: string;
  action: AuditActionEnum;
  actionDescription: string;
  userId?: string;
  userName: string;
  origin: AuditOriginEnum;
  changeCount: number;
}

export interface IAuditLogDetail {
  id: string;
  timestamp: string;
  entityName: string;
  moduleName: string;
  entityId: string;
  entityDisplayName?: string;
  action: AuditActionEnum;
  actionDescription: string;
  userId?: string;
  userName: string;
  userEmail?: string;
  origin: AuditOriginEnum;
  ipAddress?: string;
  changes: IAuditChange[];
}

export interface IAuditFilter {
  startDate?: string;
  endDate?: string;
  userId?: string;
  action?: AuditActionEnum;
  entityName?: string;
  entityId?: string;
  customerId?: string;
  searchText?: string;
  orderByField?: string;
  orderByDirection?: number;
  skip: number;
  take: number;
}
